{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "title": "FieldClassesFile",
  "description": "The albedo class each field region of the layout takes from Cornelis Anthonisz.'s 1538 painting, keyed by layout id: every polder id, every garden id, 'meadow' and 'northShore'. Written by tools/fields from docs/reference/cornelis-anthonisz-1538.jpg seen through the painter camera (src/data/painterView.json).",
  "type": "object",
  "additionalProperties": false,
  "required": ["version", "source", "method", "regions"],
  "properties": {
    "version": { "description": "Schema version.", "const": 1 },
    "source": {
      "title": "FieldClassesSource",
      "type": "object",
      "additionalProperties": false,
      "required": ["image", "width", "height"],
      "properties": {
        "image": { "type": "string", "description": "Project-relative path of the painting." },
        "width": { "type": "integer", "description": "Pixels." },
        "height": { "type": "integer", "description": "Pixels." }
      }
    },
    "method": {
      "title": "FieldClassesMethod",
      "type": "object",
      "additionalProperties": false,
      "required": ["blurSigmaPx", "stepPx", "minPixels", "candidates"],
      "properties": {
        "blurSigmaPx": {
          "type": "number",
          "description": "Standard deviation of the Gaussian blur applied to the painting before sampling, pixels."
        },
        "stepPx": {
          "type": "integer",
          "minimum": 1,
          "description": "Every stepPx-th pixel in each direction is sampled."
        },
        "minPixels": {
          "type": "integer",
          "minimum": 1,
          "description": "Fewest voting pixels for a region to count as in frame; a polder, the meadow or the north shore with fewer takes the class of the nearest region that has them, and a garden with fewer keeps the class its own pixels voted for, or gardenGrass where none did."
        },
        "candidates": {
          "type": "array",
          "items": { "$ref": "#/$defs/FieldClass" },
          "minItems": 1,
          "description": "Albedo classes the pixels vote among, each fogged to the pixel's painter-view distance."
        }
      }
    },
    "regions": {
      "type": "object",
      "description": "Keyed by layout polder id, layout garden id, 'meadow' and 'northShore'.",
      "additionalProperties": { "$ref": "#/$defs/FieldRegion" }
    }
  },
  "$defs": {
    "FieldClass": {
      "title": "FieldClass",
      "description": "Palette class used as the region's albedo.",
      "enum": ["nearFields", "polderFields", "gardenGrass"]
    },
    "FieldVotes": {
      "title": "FieldVotes",
      "description": "How many of a region's voting pixels voted for each candidate; they add up to its pixels, so a class's share of the region's votes is its count over pixels.",
      "type": "object",
      "additionalProperties": false,
      "required": ["nearFields", "polderFields", "gardenGrass"],
      "properties": {
        "nearFields": { "type": "integer", "minimum": 0 },
        "polderFields": { "type": "integer", "minimum": 0 },
        "gardenGrass": { "type": "integer", "minimum": 0 }
      }
    },
    "FieldRegion": {
      "title": "FieldRegion",
      "type": "object",
      "additionalProperties": false,
      "required": ["class", "pixels", "votes"],
      "properties": {
        "class": { "$ref": "#/$defs/FieldClass" },
        "pixels": {
          "type": "integer",
          "minimum": 0,
          "description": "Sampled painting pixels over the region that voted."
        },
        "votes": { "$ref": "#/$defs/FieldVotes" },
        "borrowedFrom": {
          "type": "string",
          "minLength": 1,
          "description": "The region whose class this region, a polder, the meadow or the north shore, takes because it had fewer than minPixels voting pixels. A garden never borrows."
        }
      }
    }
  }
}
